import { jsxs as o, jsx as t } from "react/jsx-runtime";
import { CarouselHeader as r } from "../CarouselHeader/index.js";
import { TextVideoCardCarousel as n } from "../TextVideoCardCarousel/index.js";
function C(e) {
  return /* @__PURE__ */ o("div", { children: [
    /* @__PURE__ */ t(
      r,
      {
        reviewCount: e == null ? void 0 : e.reviewCount,
        rating: e.rating,
        slug: e.slug,
        textColor: e.headerTextColor,
        alignment: e.headerAlignment
      }
    ),
    /* @__PURE__ */ t(
      n,
      {
        token: e.token,
        reviews: e.reviews,
        controlsBackgroundColor: e.controlsBackgroundColor,
        hasControls: e.hasControls
      }
    )
  ] });
}
export {
  C as TextVideoCardsCarouselWidget
};
